import {debounce} from 'lodash';
import React, {FC, useState} from 'react';

import {LeftPanel} from '../../../../../../../src/components/app/leftPanel';
import {maxLeftPanelWidth} from '../../../../../../../src/components/app/leftPanelHelpers';
import {StyledStretchGridItem} from '../../../../../../../src/components/common/grid';
import {ResizeSeparator} from '../../../../../../../src/components/common/resizeSeparator';
import {
  LocalPreferencesSizes,
  LocalPreferencesSizesEnum,
} from '../../../../../../../src/models/api/localPreferencesModel';
import {SizeUpdater} from '../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {ContactsManagerParametersTypesEnum} from '../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {HandlerOf} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../../shared/ui/src/theme/userThemeProvider';
import {ContactsManagerNavigationItems} from './contactsManagerNavigationItems';

/*
 * Constants.
 */

const minContactsManagerNavigationWidth = 230;
const maxContactsManagerNavigationWidth = maxLeftPanelWidth;

/*
 * Types.
 */

interface ContactsManagerNavigationProps {
  currentRouteType: ContactsManagerParametersTypesEnum | undefined;
  sizes: LocalPreferencesSizes;
  hasNewContactsManagerV0: boolean;
  hasNewContactsManagerAccounts: boolean;
  updateSize: SizeUpdater;
  onNavigate: HandlerOf<ContactsManagerParametersTypesEnum>;
}

/*
 * Component.
 */

export const ContactsManagerNavigation: FC<ContactsManagerNavigationProps> = (props) => {
  const {
    sizes,
    currentRouteType,
    hasNewContactsManagerV0,
    hasNewContactsManagerAccounts,
    updateSize,
    onNavigate,
  } = props;
  const [navigationWidth, setNavigationWidth] = useState(
    sizes[LocalPreferencesSizesEnum.CONTACTS_MANAGER_NAVIGATION],
  );

  const theme = useUserTheme();

  if (!hasNewContactsManagerV0) {
    return null;
  }

  const onNavigationWidthChange: HandlerOf<number> = (newWidth) => {
    setNavigationWidth(newWidth);
    saveNavigationWidthDebounce(newWidth);
  };

  const saveNavigationWidthDebounce = debounce((newWidth: number) => {
    updateSize(LocalPreferencesSizesEnum.CONTACTS_MANAGER_NAVIGATION, newWidth);
  }, 1000);

  return (
    <>
      <StyledStretchGridItem column={1} style={{width: navigationWidth}}>
        <LeftPanel panelId={undefined} interactionId="contacts-manager-navigation">
          <ContactsManagerNavigationItems
            currentRouteType={currentRouteType}
            hasNewContactsManagerAccounts={hasNewContactsManagerAccounts}
            onNavigate={onNavigate}
          />
        </LeftPanel>
      </StyledStretchGridItem>
      <ResizeSeparator
        column={2}
        size={navigationWidth}
        minSize={minContactsManagerNavigationWidth}
        maxSize={maxContactsManagerNavigationWidth}
        onSizeChange={onNavigationWidthChange}
        color={theme.separator}
      />
    </>
  );
};
